import { useMemo } from 'react';

import { useContactsSelector } from '@components/ContactsSelector/Common/ContactsSelectorContext';

/**
 * ID delle feature su cui si sta filtrando in questo momento, per evidenziarle nella wall.
 *
 * Ogni tipo di lista usa una sola sorgente di filtri: i quick filters valgono solo in 'all',
 * i filtri della smart list solo in 'smart-lists' (vedi ModelsSelector).
 *
 * Il Set va calcolato una volta sopra la lista e passato alle righe come prop: calcolarlo
 * dentro la singola card significherebbe allocarne uno per ogni modella a video.
 */
const useFilteredFeatureIDs = () => {
    const { selection } = useContactsSelector();
    const { filters, listType, quickFilters } = selection;

    return useMemo(() => {
        if (listType === 'all' && quickFilters && quickFilters.showFeaturesQuickFilters) {
            const featuresQuickFilters = quickFilters.featuresQuickFilters || {};
            // una chiave senza valore è un filtro spento
            return new Set(Object.keys(featuresQuickFilters).filter((featureID) => featuresQuickFilters[featureID]));
        }
        if (listType === 'smart-lists' && filters && filters.active) {
            return new Set(filters.active.filter((filter) => filter.source === 'feature').map((filter) => filter.name));
        }
        return new Set();
    }, [filters, listType, quickFilters]);
};

export default useFilteredFeatureIDs;
